import { api } from './client';

// ============================================
// Types — mirrors google_ad_insights table
// ============================================

export interface GgInsightRow {
  date: string;
  account_id?: string;
  account_name?: string;
  dimension_value?: string;

  // additive (SUM)
  cost_micros: number;
  spend: number;
  impressions: number;
  clicks: number;
  conversions: number;
  conversions_value: number;
  all_conversions: number;
  all_conversions_value: number;
  interactions: number;
  view_through_conversions: number;
  engagements: number;
  purchase_count: number;
  purchase_value: number;

  // ratio (calculated)
  ctr: number;
  average_cpc: number;
  average_cpm: number;
  cost_per_conversion: number;
  cost_per_all_conversions: number;
  conversions_from_interactions_rate: number;
  all_conversions_from_interactions_rate: number;
  value_per_conversion: number;
  value_per_all_conversions: number;
  interaction_rate: number;
  engagement_rate: number;
  absolute_top_impression_percentage: number;
  top_impression_percentage: number;
  roas: number;
  purchase_roas: number;
  cost_per_purchase: number;
}

export interface GgInsightListParams {
  brand_id: string;
  site_id?: string;
  start_date: string;
  end_date: string;
  account_ids?: string;
  dimension?: string;
  ad_id?: string;
  ad_name?: string;
  campaign_name?: string;
  ad_group_name?: string;
  target_layer?: string;
  customer_type?: string;
  ad_format_tag?: string;
  creative_type?: string;
  price_range?: string;
  product_position?: string;
  funnel_detail?: string;
  funnel_level?: string;
  campaign_type?: string;
  page?: number;
  size?: number;
}

export interface TagOption {
  value: string;
  label: string;
}

export interface TagFilterGroup {
  key: string;
  label: string;
  options: TagOption[];
}

export interface GgInsightListResponse {
  code: number;
  message: string;
  data: {
    list: GgInsightRow[];
    total: number;
    page: number;
    size: number;
    total_page: number;
    summary: GgInsightRow | null;
  };
}

export interface AccountOption {
  account_id: string;
  account_name: string;
}

export interface DimensionOption {
  value: string;
  label: string;
}

// ============================================
// API
// ============================================

export const ggInsightsApi = {
  getList: (params: GgInsightListParams) =>
    api.get<GgInsightListResponse>('/gg-insights/list', { params }),

  getAccounts: (params: { brand_id: string; site_id?: string; scope?: 'dashboard_read' | 'dashboard_export' }) =>
    api.get<{ code: number; data: AccountOption[] }>('/gg-insights/accounts', { params }),

  getDimensions: () =>
    api.get<{ code: number; data: DimensionOption[] }>('/gg-insights/dimensions'),

  getTagOptions: (params: { brand_id: string }) =>
    api.get<{ code: number; data: TagFilterGroup[] }>('/gg-insights/tag-options', { params }),
};
